import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import get from "lodash/get";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { bindActionCreators } from "redux";
import CallOutNew from "Component/Headers/callOutNew";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { checkboxinputconverter } from "../../../../../../Component/DynamicForm/Fields/CheckBox";
import CheckImg from "../../../../../../Assets/Svg/check.svg";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../../Constants";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

const POST_DATA = {
  businessunitid: null, // null,
  logoplacementtypeid: null, // 1,
  bodyplacementtypeid: null, // 1,
  signatureplacementtypeid: null, // 1
  showempdeducation: true,
  showemrdeducation: true,
  showpaybank: true,
  isbusinessunitaddress: false,
};

class SalarySlip extends React.Component {
  state = {
    postdata: POST_DATA,
  };

  componentDidMount() {
    this.getdata();
  }

  getdata = () => {
    instance
      .get("payroll/salaryslipdesign")
      .then((resp) => {
        this.setState({
          postdata: get(resp, "data.result[0]", POST_DATA),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  submit = () => {
    const { postdata } = this.state;
    const data = {
      ...postdata,
    };
    if (
      !data.logoplacementtypeid ||
      !data.bodyplacementtypeid ||
      !data.signatureplacementtypeid
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0130, { variant: "error" });
      return;
    }
    instance
      .post("payroll/salaryslipdesign", data)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.getpayrollconfig();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  updatepostdata = (key, value) => {
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  };

  render() {
    const {
      postdata: {
        logoplacementtypeid,
        bodyplacementtypeid,
        signatureplacementtypeid,
        showempdeducation,
        showemrdeducation,
        showpaybank,
        isbusinessunitaddress,
      },
    } = this.state;
    return (
      <IntlProvider locale="en" messages={""}>
        <div className="width100">
          <Helmet>
            <title>{headersList.Config.Misc.SalarySlipDesign.header}</title>
          </Helmet>
          <Grid container>
            <Grid md={12} xs={12} lg={12} sm={12}>
              <div>
                <PageHeader header="Design your salary slip " />
              </div>
            </Grid>
          </Grid>
          <p className="normal-dark-secondary t-bold margin-bottom-16">
            Logo placement
          </p>
          <Grid container spacing={3} className="margin-left-0 margin-top-16">
            <Grid
              md={3}
              lg={3}
              sm={6}
              onClick={() => this.updatepostdata("logoplacementtypeid", 1)}
            >
              <div
                className={`slip-design-element ${
                  logoplacementtypeid == 1 && "block-selected"
                }`}
              >
                <div className="floatleft">
                  <span className="logo-dummy">Logo</span>
                </div>
                <div className="floatright">
                  <span className="dummy-line"></span>
                  <span className="dummy-line1" style={{ left: 14 }}></span>
                  <span className="dummy-line"></span>
                </div>
                {logoplacementtypeid == 1 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid>
            {/* <Grid md={3} lg={3} sm={6} onClick={() => this.updatepostdata("logoplacementtypeid", 2)}>
              <div className={`slip-design-element ${logoplacementtypeid == 2 && "block-selected"}`}>
                <div>
                  <span className="logo-dummy" style={{ margin: "0 auto" }}>
                    Logo
                  </span>
                </div>
                <div className="margin-top-8">
                  <span className="dummy-line" style={{ margin: "0 auto" }}></span>
                  <span className="dummy-line1" style={{ margin: "4px auto" }}></span>
                  <span className="dummy-line" style={{ margin: "0 auto" }}></span>
                </div>
                {logoplacementtypeid == 2 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid> */}
            {/* <Grid md={3} lg={3} sm={6} onClick={() => this.updatepostdata("logoplacementtypeid", 3)}>
              <div className={`slip-design-element ${logoplacementtypeid == 3 && "block-selected"}`}>
                <div className="floatright">
                  <span className="logo-dummy">Logo</span>
                </div>
                <div className="floatleft">
                  <span className="dummy-line"></span>
                  <span className="dummy-line1"></span>
                  <span className="dummy-line"></span>
                </div>
                {logoplacementtypeid == 3 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid> */}
          </Grid>
          <p className="normal-dark-secondary t-bold margin-bottom-16">
            Body layout
          </p>
          <Grid container spacing={3} className="margin-left-0 margin-top-16">
            <Grid
              md={3}
              lg={3}
              sm={12}
              onClick={() =>
                this.props.permissions &&
                this.props.permissions.editable &&
                this.updatepostdata("bodyplacementtypeid", 1)
              }
            >
              <div
                className={`slip-design-element ${
                  bodyplacementtypeid == 1 && "block-selected"
                }`}
              >
                <div className="floatleft" style={{ width: "45%" }}>
                  <span className="dummy-body1"></span>
                </div>
                <div className="floatright" style={{ width: "45%" }}>
                  <span className="dummy-body1"></span>
                </div>
                {bodyplacementtypeid == 1 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid>
            {/* <Grid md={3} lg={3} sm={12} onClick={() => this.updatepostdata("bodyplacementtypeid", 2)}>
              <div className={`slip-design-element ${bodyplacementtypeid == 2 && "block-selected"}`}>
                <div>
                  <span className="dummy-body"></span>
                </div>
                {bodyplacementtypeid == 2 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid> */}
          </Grid>
          <p className="normal-dark-secondary t-bold margin-bottom-16">
            Choose the deduction sections you want to show in the employee's
            salary slip.
          </p>
          <Grid container>
            <Grid item sm={12}>
              <DynamicForm
                fields={checkboxinputconverter({
                  value: showempdeducation,
                  placeholder: "",
                  label: "Show Employee Deduction",
                  disabled:
                    this.props.permissions && !this.props.permissions.editable,
                })}
                onChange={(value) =>
                  this.updatepostdata("showempdeducation", !showempdeducation)
                }
              />
            </Grid>
            {/* <Grid item sm={12} md={11}>
              <p
                className="small-dark-secondary t-bold"
                style={{ lineHeight: "24px" }}
              >
                Show Employee Deducation
                        </p>
            </Grid> */}
          </Grid>
          <Grid container>
            <Grid item sm={12}>
              <DynamicForm
                fields={checkboxinputconverter({
                  value: showemrdeducation,
                  placeholder: "",
                  label: "Show Employer Deduction",
                  disabled:
                    this.props.permissions && !this.props.permissions.editable,
                })}
                onChange={(value) =>
                  this.updatepostdata("showemrdeducation", !showemrdeducation)
                }
              />
            </Grid>
            {/* <Grid item sm={12} md={11}>
              <p
                className="small-dark-secondary t-bold"
                style={{ lineHeight: "24px" }}
              >
                Show Employer Deducation
                        </p>
            </Grid> */}
          </Grid>
          <Grid container>
            <Grid item sm={12}>
              <DynamicForm
                fields={checkboxinputconverter({
                  value: showpaybank,
                  placeholder: "",
                  label: "Show Bank Details",
                  disabled:
                    this.props.permissions && !this.props.permissions.editable,
                })}
                onChange={(value) =>
                  this.updatepostdata("showpaybank", !showpaybank)
                }
              />
            </Grid>
          </Grid>
          <p className="normal-dark-secondary t-bold margin-bottom-8 margin-top-8">
            Do you want to show Business unit specific payslips?
          </p>

          <CallOutNew
            classnames="bg-light-blue width80 margin-bottom-8"
            header="Enable this feature if your
                business units are incorporated entities
                and you want employee's payslips
                to show the Business Unit's name."
            emoji=""
            textcolor="#1e8ced"
          />

          <Grid container>
            <Grid item sm={12} md={3}>
              <div className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: isbusinessunitaddress,
                    label: "Yes",
                  })}
                  onChange={() =>
                    this.updatepostdata("isbusinessunitaddress", true)
                  }
                />
              </div>
              <div className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: !isbusinessunitaddress,
                    label: "No",
                  })}
                  onChange={() =>
                    this.updatepostdata("isbusinessunitaddress", false)
                  }
                />
              </div>
            </Grid>
          </Grid>

          <p className="normal-dark-secondary t-bold margin-bottom-16">
            Signing authority
          </p>
          <Grid container spacing={3} className="margin-left-0 margin-top-16">
            <Grid
              md={3}
              lg={3}
              sm={12}
              onClick={() =>
                this.props.permissions &&
                this.props.permissions.editable &&
                this.updatepostdata("signatureplacementtypeid", 1)
              }
            >
              <div
                className={`slip-design-element ${
                  signatureplacementtypeid == 1 && "block-selected"
                }`}
              >
                <div className="position-rel">
                  <p
                    className="normal-dark-secondary"
                    style={{
                      position: "absolute",
                      top: 50,
                      left: 0,
                      right: 0,
                      margin: "auto",
                      textAlign: "center",
                    }}
                  >
                    None
                  </p>
                </div>
                {signatureplacementtypeid == 1 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid>
            <Grid
              md={3}
              lg={3}
              sm={12}
              onClick={() =>
                this.props.permissions &&
                this.props.permissions.editable &&
                this.updatepostdata("signatureplacementtypeid", 2)
              }
            >
              <div
                className={`slip-design-element ${
                  signatureplacementtypeid == 2 && "block-selected"
                }`}
              >
                <div className="position-rel">
                  <p
                    className="normal-dark-secondary"
                    style={{
                      position: "absolute",
                      top: 50,
                      left: 0,
                      right: 0,
                      margin: "auto",
                      textAlign: "center",
                    }}
                  >
                    Digital Signature
                  </p>
                </div>
                {signatureplacementtypeid == 2 && (
                  <div className="element-selected">
                    <img src={CheckImg} height="24"></img>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
          {this.props.permissions && this.props.permissions.editable && (
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                sm={12}
                style={{ justifyContent: "flex-start", display: "flex" }}
              >
                <div className="">
                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    onClick={this.submit}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(SalarySlip)));
